import React from 'react';
import dayjs from 'dayjs';
import styled from 'styled-components';

import {
  PROGRAM_TIME_FORMAT,
  COMPLEX_GRID_MIN_TEXT_WIDTH
} from '../../constants';
import Link from 'shared/components/presentational/CustomLink/CustomLink';
import pxInRem from 'shared/helpers/styled-components/remHelper';
import _Picture from 'shared/components/presentational/Picture';
import mediaQueries from 'shared/helpers/styled-components/mediaQueries';
import { FONT_FAMILIES, FONT_WEIGHTS } from 'shared/constants/theme';

const ContentWrapper = styled(Link)`
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  overflow: hidden;
  height: 130px;
`;

const Content = styled.div`
  position: relative;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  padding: 15px 10px;
  height: 130px;
  min-width: ${COMPLEX_GRID_MIN_TEXT_WIDTH}px;
`;

const Time = styled.div`
  height: 25px;
  font-family: ${FONT_FAMILIES.base};
`;

const Title = styled.div`
  position: relative;
  font-size: ${pxInRem('15px')};
  font-family: ${FONT_FAMILIES.base};
  font-weight: ${FONT_WEIGHTS.bold};
  line-height: ${pxInRem('20px')};
  margin: 5px 0 10px;
  word-wrap: break-word;
  overflow: hidden;
  height: 60px;

  &:after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    right: 0;
    height: ${pxInRem('20px')};
    width: 100%;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      #fff 100%
    );
  }
`;

const Type = styled.div`
  position: absolute;
  bottom: 15px;
  left: 10px;
  right: 10px;
  font-size: ${pxInRem('12px')};
  font-family: ${FONT_FAMILIES.base};
  color: ${props => props.theme.tvGuide.program.type.color};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const PictureWrapper = styled.div`
  pointer-events: none;
  padding: 15px 0 15px 10px;
  height: 100%;
  box-sizing: border-box;
  width: 170px;
  display: flex;
  ${mediaQueries.toPhablet`
    display: none;
  `};

  img {
    width: 100%;
  }
`;

const Picture = styled(_Picture)`
  width: 100%;
`;

export const ProgramLink = ({
  programLink,
  firstProgram,
  timezone,
  showPicture,
  setPictureOnError
}) => (
  <ContentWrapper to={programLink}>
    <Content>
      <Time>
        {dayjs
          .unix(firstProgram.startTime)
          .tz(timezone)
          .format(PROGRAM_TIME_FORMAT)}
      </Time>
      <Title>{firstProgram.title}</Title>
      <Type>{firstProgram.subtitle}</Type>
    </Content>
    {showPicture && (
      <PictureWrapper>
        <Picture
          onError={setPictureOnError}
          url={firstProgram.URLImage}
          width={160}
          height={100}
        />
      </PictureWrapper>
    )}
  </ContentWrapper>
);
